<template>
  <div class="grid w-full grid-cols-4 items-center space-x-1">
    <div v-tooltipable class="col-span-3 truncate">
      {{ data.names || "-" }}
    </div>
    <div class="flex items-center">
      <total-indicator
        v-if="data.count"
        v-tooltip="$t('INBOX.NUMBER_OF_MESSAGES')"
        :value="data.count"
      />
      <links-clicked-tooltip-icon
        v-if="!!data.linksClicked?.length"
        :links-clicked="data.linksClicked"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import LinksClickedTooltipIcon from "@/components/communicationLogs/communication/emailThread/LinksClickedTooltipIcon.vue";
import TotalIndicator from "@/components/deals/dataServices/cfa/moneythumb/TotalIndicator.vue";

import type { EmailLinksClicked } from "@/models/communicationLogs";

const { data } = defineProps<{
  data: { names: string; count: number; linksClicked?: EmailLinksClicked[] };
}>();
</script>
